import { useState } from 'react';
import {
    Container,
    Header,
    Content
} from './styled';
import { Card } from './Card';
import { useAuth } from '../../contexts/auth';
import { toast } from 'react-toastify';
import { IoIosSearch } from "react-icons/io";



export function SelectCompanies(props) {

    const {
        companies,
        user,
        username,
        password,
        statusUser
    } = props

    const {
        signIn
    } = useAuth()

    const [search, setSearch] = useState('')

    async function handleSelectCompany(idCompany) {
        const response = await signIn(
            username,
            password,
            idCompany,
            user.id,
            statusUser
        )
        if (response.error)
            toast.error(
                `${response?.message}`,
                { position: "top-center", theme: "colored" }
            );
        return
    }

    function onFilterCompanies(company) {
        return company?.nome?.toLowerCase().includes(search?.toLowerCase()) ||
        company?.descricao?.toLowerCase().includes(search?.toLowerCase())
    }

    return (
        <Container>
            <Header>
                <h1>{`Selecione uma empresa:`}</h1>
                <div>
                    <input
                        type="text"
                        placeholder="Buscar empresa..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                    <IoIosSearch />
                </div>
            </Header>
            <Content>
                {(companies.length > 0) &&
                    companies?.filter(onFilterCompanies)?.map((company) => {
                        return (
                            <Card
                                onClick={
                                    () => handleSelectCompany(company.id)
                                }
                                key={company.id}
                                company={company}
                            />
                        )
                    })
                }
            </Content>
        </Container>
    )
}